import {
    defineComponent,
    watchEffect,
} from "vue";
import { useRoute } from "vue-router";
import { useLocale } from "../../locales/i18n.js";
import { applyUnauthorizedSeo } from "./privateSeo.js";
import PublicErrorPage from "./PublicErrorPage.js";

export default defineComponent({
    setup() {
        const { i18n } = useLocale();
        const route = useRoute();

        watchEffect(() => {
            applyUnauthorizedSeo(
                route.path,
                i18n("error.401.seo_title"),
                i18n("error.401.seo_description"),
            );
        });

        return () => (
            <PublicErrorPage
                actions={[
                    {
                        href    : "/api/oauth2",
                        icon    : "arrow_forward",
                        label   : i18n("public.error.401.oauth"),
                        variant : "primary",
                    },
                    {
                        icon    : "home",
                        label   : i18n("public.error.401.home"),
                        to      : "/",
                        variant : "secondary",
                    },
                ]}
                code="401"
                description={i18n("error.401.seo_description")}
                icon="lock"
                kicker={i18n("public.error.401.kicker")}
                title={i18n("error.401.title")}
            />
        );
    },
});
